export const custom = {
  global: {
    colors: {
      brand: "#056a96ff",
    },
  },
  checkBox: {
    check: {
      extend: `
          display: flex;
          align-items: center;
          justify-content: center;
        `,
    },
    icon: {
      size: "20px", // Adjust size if needed
      toggle: {},
      background: "none",
    },
  },
};
